import React from 'react'
import { CashBundle } from 'assets/icons'
import HeaderWithExportOptions from 'components/HeaderWithExportOptions'
import { withTranslation } from 'react-i18next'

export default withTranslation()(function EmptySettlement({ t }) {
  return (
    <section className="w-full bg-white py-8 px-12 rounded-xl mb-5 shadow-sm">
      <HeaderWithExportOptions 
        title={t('settlements.table.title')}
        exportOptions={[
          {
            name: t('settlements.export')
          }
        ]}
      />

      <div className="w-full h-80 flex flex-col items-center justify-center">
        <div className="w-24 h-24 flex justify-center mb-7 items-center rounded-full bg-border-lines">
          <CashBundle classList="h-10" />
        </div>
        
        <p className="text-placeholder w-2/5 mx-auto text-center">{ t('settlements.empty') }</p>
      </div>
    </section>
  )
})